import a from "./index216.mjs";
import * as e from "react";
import { j as c } from "./index58.mjs";
import t from "./index719.mjs";
function u(n, r) {
  function o(m, i) {
    return /* @__PURE__ */ c.jsx(t, a({
      "data-testid": `${r}Icon`,
      ref: i
    }, m, {
      children: n
    }));
  }
  return process.env.NODE_ENV !== "production" && (o.displayName = `${r}Icon`), o.muiName = t.muiName, /* @__PURE__ */ e.memo(/* @__PURE__ */ e.forwardRef(o));
}
export {
  u as default
};
